// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import React from 'react';
import { useLocalize } from '@ta/platform.i18n';
import { Icon } from '@ta/styleguide.icon';
import styles from './EditCta.css';

type Props = {|
  /**
   * A description of the user's trip preferences, rendered as a string by
   * useExplicitPreferencesDescription
   */
  description: string,
  onClick: () => mixed,
|};

/**
 * A button to enter the Explicit Preferences flow again after preferences have already been
 * submitted
 */
const EditCta = ({ description, onClick }: Props) => {
  const { localize } = useLocalize();

  return (
    <button className={styles.editCta} onClick={onClick}>
      <div className={styles.header}>
        {localize('cx_explicit_preferences_edit_cta_header') /* Your trip details */}
      </div>
      <div className={styles.description}>{description}</div>
      <div>
        <Icon className={styles.icon} name="filter" />
        <span className={styles.editTripDetails}>
          {localize('cx_explicit_preferences_edit_trip_details') /* Edit trip details */}
        </span>
      </div>
    </button>
  );
};

export default EditCta;
